export default async ({ store }) => {
  const { default: createPersistedState } = await import('vuex-persistedstate')
  const options = { key: 'interactions', paths: ['interactions'] }

  createPersistedState(options)(store)
}
